<template>
    <b-card no-body>
        <b-modal id="hakedisler" body-class="p-0" title="Hakedişler" hide-footer no-close-on-esc no-close-on-backdrop>
            <excuse-annual-hakedis v-model="hakedisler"/>
        </b-modal>
        <b-modal id="kullanilanlar" size="lg" body-class="p-0" title="Kullanılan Yıllık İzinler" hide-footer no-close-on-esc no-close-on-backdrop>
            <excuse-annual-kullanilan v-model="kullanilanlar" :total-used="totalUsed"/>
        </b-modal>

        <v-table    ref="table"
                    :items-provider="provider"
                    :fields="fields"
                    pagination="server"
                    :settings="false"
                    :buttons="buttons"
                    :editor="(res) => res.Data.Data"
                    v-on:fetch-result="$e => excelPath = ($safe($e,'ExcelPath') || null)"
                    >
                <template #additional-actions>
                    <div class="row">
                        <div class="col-lg-1 mb-1 mb-lg-0">
                            <select class="form-control bg-img-none" v-model="donem.month">
                                <option v-for="m in months" :key="m.index" :value="m.index">{{m.name}}</option>
                            </select>
                        </div>
                        <div class="col-lg-1 mb-1 mb-lg-0">
                            <select class="form-control bg-img-none" v-model="donem.year">
                                <option v-for="y in years" :key="y" :value="y">{{y}}</option>
                            </select>
                        </div>
                        <div class="col-lg-auto mb-1 mb-lg-0">
                            <select class="form-control bg-img-none" v-model="branchType">
                                <option value="O">Org. Şube</option>
                                <option value="S">SGK Şube</option>
                            </select>
                        </div>
                        <div class="col-lg-2 mb-1 mb-lg-0" v-if="branchType == 'O'">
                            <v-select-list :options="branches" label="Name" v-model="branch" placeholder="Tüm Org. Şubeler"></v-select-list>
                        </div>
                        <div class="col-lg-2 mb-1 mb-lg-0" v-if="branchType == 'S'">
                            <v-select-list :options="sbranches" label="Name" v-model="sbranch" placeholder="Tüm SGK Şubeler"></v-select-list>
                        </div>
                        <div class="col-lg-2 mb-1 mb-lg-0">
                            <v-select-list :options="collarStatuses" label="Name" v-model="collarStatus" placeholder="Tüm Yakalar"></v-select-list>
                        </div>
                        <div class="col-lg-auto mb-1 mb-lg-0">
                            <select class="form-control bg-img-none" v-model="jobExit">
                                <option :value="null">Tümü</option>
                                <option :value="false">Çalışıyor</option>
                                <option :value="true">Ayrıldı</option>
                            </select>
                        </div>
                        <div class="col-lg-2 mb-1 mb-lg-0">             
                            <b-input-group class="input-group-merge">
                                <template #prepend>
                                    <b-input-group-text >
                                        <feather-icon icon="SearchIcon"></feather-icon>
                                    </b-input-group-text>
                                </template>
                                <b-form-input placeholder="Ara..." v-on:keyup.enter="$refs.table.refresh()" v-model="searchValue"></b-form-input>
                            </b-input-group>
                        </div>
                        <div class="col-lg-auto">
                            <button class="btn w-100 btn-success" v-on:click="$refs.table.refresh()">Sorgula</button>
                        </div>
                        <div class="col-lg-auto ml-auto">
                            <b-dropdown text="İşlemler" right variant="primary" v-if="excelPath">
                                <b-dropdown-item v-on:click="downloadExcel">
                                    <feather-icon icon="FileIcon" class="mr-50"></feather-icon>
                                    Excel İndir
                                </b-dropdown-item>
                            </b-dropdown>
                        </div>
                    </div>
                </template>
                </v-table>
    </b-card>
</template>

<script>
import { BCard, BInputGroup, BInputGroupText, BFormInput, BDropdown, BDropdownItem } from 'bootstrap-vue'
import EmployeeOperationsApi from '@/api/employee-operations'
import SystemDataApi from '@/api/system-data'
import CompanyApi from '@/api/company'
import moment from 'moment'
import ExcuseAnnualHakedis from './components/ExcuseAnnualHakedis.vue'
import ExcuseAnnualKullanilan from './components/ExcuseAnnualKullanilan.vue'
import Additional from '@/utilities/additional'

export default {
    components:{
        BCard,
        BInputGroup, 
        BInputGroupText, 
        BFormInput,
        ExcuseAnnualHakedis,
        ExcuseAnnualKullanilan,
        BDropdown, 
        BDropdownItem
    },
    data(){
        return {
            fields:[
                {name:'Personel',key:'FullName',thClass:'w-16',sortable:true},
                {name:'Unvan',key:'EmployeeDepartmentTitle',thClass:'w-16',sortable:true},
                {name:'Doğum Tarihi',key:'BirthDateStr',thClass:'w-16'},
                {name:'Giriş Tarihi',key:'AnnualHoliday.JobStartDateStr',thClass:'w-16'},
                {name:'Çıkış Tarihi',key:'AnnualHoliday.JobEndDateStr',thClass:'w-16'},
                {name:'Kullanılan',key:'AnnualHoliday.Used',thClass:'w-14'},
                {name:'Kalan',key:'AnnualHoliday.Remaining',thClass:'w-14'},
                {name:'Toplam',key:'AnnualHoliday.Total',thClass:'w-14'},
            ],
            donem:{
                year:moment().year(),
                month:moment().month() + 1 
            },
            years:[],
            months:[
                {index:1,name:'Ocak'},
                {index:2,name:'Şubat'},
                {index:3,name:'Mart'},
                {index:4,name:'Nisan'},
                {index:5,name:'Mayıs'},
                {index:6,name:'Haziran'},
                {index:7,name:'Temmuz'},
                {index:8,name:'Ağustos'},
                {index:9,name:'Eylül'},
                {index:10,name:'Ekim'},
                {index:11,name:'Kasım'},
                {index:12,name:'Aralık'}
            ],
            branches:[],
            sbranches:[],
            collarStatuses:[],
            branchType:'S',
            branch:null,
            sbranch:null,
            collarStatus:null,
            jobExit:false,
            buttons:[
                { text:"Hakedişler",key:"list",icon:"ListIcon",variant:"primary",action:this.showHakedis },
                { text:"Kullanılanlar",key:"list",icon:"UserCheckIcon",variant:"info",action:this.showKullanilanlar },
            ],
            hakedisler:[],
            kullanilanlar:[],
            totalUsed:0,
            searchValue:'',
            excelPath:null
        }
    },
    mounted(){
        this.configureYears()
        this.getBranches()
        this.getSBranches()
        this.getCollarStatuses()
    },
    methods:{
        provider(data){
            return EmployeeOperationsApi.Excuse.RemainingAnnualHoliday({
                SalaryFilter:{
                    ...this.filter,
                    PaginateRequest:{
                        ...data,
                        QueryParam:this.searchValue,
                        OrderColumnName: data.OrderColumnName || 'FullName',
                        IsAscending:  data.OrderColumnName == null ? true : data.IsAscending
                    }
                },
                JobExit:this.jobExit
            })
        },
        getBranches(){
            CompanyApi.Branch.ListByCode("O").then(res=>{
                this.branches = res.data.Data
            })
        },
        getSBranches(){
            CompanyApi.Branch.ListByCode("S").then(res=>{
                this.sbranches = res.data.Data
            })
        },
        getCollarStatuses(){
            SystemDataApi.CollarStatus().then(res => {
                this.collarStatuses = res.data.Data
            })
        },
        configureYears(){  
            let years = []
            let year = moment().add(1,'year').format('YYYY')
            let firstYear = 1900
            while (firstYear <= year){
                years.push(firstYear++)
            }
            this.years = years.reverse()
        },
        showHakedis(row){
            this.hakedisler = []
            this.hakedisler = (row?.AnnualHoliday?.Hakedisler || [])
            this.$showModal('hakedisler')
        },
        showKullanilanlar(row){
            this.kullanilanlar = []
            this.totalUsed = 0
            this.kullanilanlar = (row?.AnnualHoliday?.UsedDetails || [])
            this.totalUsed = (row?.AnnualHoliday?.TotalUsed || 0)
            this.$showModal('kullanilanlar')
        },
        downloadExcel(){
            if(this.excelPath){
                Additional.DownloadTab(this.excelPath)
            }
        }
    },
    computed:{
        filter(){
            return {
                BranchId: this.branchType == 'O' ? (this.branch?.Id || null) : (this.sbranch?.Id || null),
                BranchTypeCode: this.branchType,
                CollarStatusId: this.collarStatus?.Id || null,
                Month: this.donem.month,
                Year: this.donem.year,
            }
        }
    }
}
</script>

<style>

</style>